/*
 * author ivanm
 * when adding new field set tabindex properly
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var Button = require("ui/button/Button");
    var GoogleAnalytics = require("registration-google/GoogleAnalytics");
    var InputField = require("ui/input-field/InputField");
    var Dropdown = require("ui/dropdown/Dropdown");
    var Loader = require("ui/loader/Loader");
    var Bubble = require("ui/bubble/Bubble");
    var ValidationUtilities = require("utils/ValidationUtilities");
    var Config = require("registration-assets/config/config.json");
    var CountryUtility = require("infra-util/CountryUtility");
    var IndustryUtility = require("utils/IndustryUtility");
    var DomUtil = require("infra-util/DomUtilities");
    var RegistrationCreateAccountView = {};
    var Link = require("ui/link/Link");
    var template = require("registration-templates/registrationCreateAccountView.tmpl");
    var errorCodes = require("registration-assets/data/errorCodes.json");
    var XRegExp = require("xregexp").XRegExp;

    LE.module("LERegistration", function (LERegistration, LE, Backbone, Marionette, $, _) {
        var COMPONENTS = {
            FIRST_NAME_INPUT: "firstNameInput",
            LAST_NAME_INPUT: "lastNameInput",
            WEBSITE_INPUT: "websiteInput",
            PASSWORD_INPUT: "passwordInput",
            CONFIRM_PASSWORD_INPUT: "passwordConfirmInput"
        };

        var ERRORS = {
            FIRST_NAME_INVALID: "firstNameInvalid",
            FIRST_NAME_EMPTY: "firstNameEmpty",
            LAST_NAME_INVALID: "lastNameInvalid",
            LAST_NAME_EMPTY: "lastNameEmpty",
            WEB_SITE_INVALID: "webSiteInvalid",
            WEB_SITE_EMPTY: "webSiteEmpty",
            PASSWORD_EMPTY: "passwordEmpty",
            PASSWORD_LENGTH: "passwordLength",
            PASSWORD_MATCH: "passwordMatch"
        };

        var mapErrorToComponent = {};
        mapErrorToComponent[ERRORS.FIRST_NAME_INVALID] = COMPONENTS.FIRST_NAME_INPUT;
        mapErrorToComponent[ERRORS.FIRST_NAME_EMPTY] = COMPONENTS.FIRST_NAME_INPUT;
        mapErrorToComponent[ERRORS.LAST_NAME_INVALID] = COMPONENTS.LAST_NAME_INPUT;
        mapErrorToComponent[ERRORS.LAST_NAME_EMPTY] = COMPONENTS.LAST_NAME_INPUT;
        mapErrorToComponent[ERRORS.WEB_SITE_INVALID] = COMPONENTS.WEBSITE_INPUT;
        mapErrorToComponent[ERRORS.WEB_SITE_EMPTY] = COMPONENTS.WEBSITE_INPUT;
        mapErrorToComponent[ERRORS.PASSWORD_EMPTY] = COMPONENTS.PASSWORD_INPUT;
        mapErrorToComponent[ERRORS.PASSWORD_LENGTH] = COMPONENTS.PASSWORD_INPUT;
        mapErrorToComponent[ERRORS.PASSWORD_MATCH] = COMPONENTS.CONFIRM_PASSWORD_INPUT;

        var that;

        RegistrationCreateAccountView = Marionette.ItemView.extend({

            template: template,

            className: "registration-create-account-view",

            initialize: function (options) {
                that = this;
                this.registrationCreateAccountModel = options.registrationCreateAccountModel;
                this.automationSecret = options.automationSecret;
            },

            ui: {
                registrationFirstNameDiv: ".first-name-div",
                registrationLastNameDiv: ".last-name-div",
                registrationWebsiteDiv: ".website-div",
                registrationChoosePasswordDiv: ".choose-password-div",
                registrationConfirmPasswordDiv: ".confirm-your-password-div",
                registrationCountryDiv: ".main-country-dd",
                registrationIndustryDiv: ".main-industry-dd",
                registrationCreateAccountButton: ".create-account-button",
                licenseAgreementLink: ".license-agreement-link",
                autoLoginForm: ".auto-login-form",
                autoLoginPassord: ".auto-login-password",
                siteId: ".lp-site-id",
                username: ".user-name",
                lpservice: ".lpservice",
                servicepath: ".servicepath"
            },

            uiComponents: {
                firstNameInput: {
                    type: InputField,
                    options: {
                        el:"view.ui.registrationFirstNameDiv",
                        permutation : InputField.Permutation.M,
                        placeholder: LE.translator.translate("LERegistration.Fields.placeholder.first.name"),
                        tabindex: 1
                    }
                },
                lastNameInput: {
                    type: InputField,
                    options: {
                        el:"view.ui.registrationLastNameDiv",
                        permutation : InputField.Permutation.M,
                        placeholder: LE.translator.translate("LERegistration.Fields.placeholder.last.name"),
                        tabindex: 2
                    }
                },
                websiteInput: {
                    type: InputField,
                    options: {
                        el:"view.ui.registrationWebsiteDiv",
                        permutation : InputField.Permutation.B,
                        placeholder: LE.translator.translate("LERegistration.EnterYourWebsiteAddressURL"),
                        tabindex: 3
                    }
                },
                regLocation: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.registrationCountryDiv",
                        model: this.model,
                        name: "location",
                        selectedOption: "us",
                        items: getCountries(),
                        tabindex: 4
                    }
                },
                regIndustry: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.registrationIndustryDiv",
                        model: this.model,
                        name: 'industry',
                        selectedOption: "view._getIndustry",
                        items: getIndustries(),
                        tabindex: 5
                    }
                },
                passwordInput: {
                    type: InputField,
                    options: {
                        el:"view.ui.registrationChoosePasswordDiv",
                        type: InputField.Type.Password,
                        permutation : InputField.Permutation.B,
                        placeholder: LE.translator.translate("LERegistration.EnterYourPassword"),
                        tabindex: 6
                    }
                },
                passwordConfirmInput: {
                    type: InputField,
                    options: {
                        el:"view.ui.registrationConfirmPasswordDiv",
                        type: InputField.Type.Password,
                        permutation : InputField.Permutation.B,
                        placeholder: LE.translator.translate("LERegistration.ConfirmYourPassword"),
                        tabindex: 7
                    }
                },
                createAccountButton: {
                    type: Button,
                    options: {
                        el:"view.ui.registrationCreateAccountButton",
                        permutation:Button.PERMUTATION.BTN_PRIMARY,
                        initState:Button.STATES.ENABLED,
                        tabindex: 9
                    },
                    events: {
                        click: "registrationCreateAccount"
                    }
                },
                licenseAgreementLink: {
                    type: Link,
                    options: {
                        el:"view.ui.licenseAgreementLink",
                        href : "http://www.liveperson.com/policies/license-agreement",
                        text: LE.translator.translate("LERegistration.LicenseAgreement")
                    }
                }
            },

            events: {
                "keypress input": "keyPressEnter"
            },

            keyPressEnter: function (ev) {
                if(ev.keyCode === 13) {
                    $(".create-account-button .btn-primary").focus();
                    LERegistration.logger.info("RegistrationCreateAccountView >> keyPressEnter >> ENTER was pressed");
                    this.registrationCreateAccount(ev);
                }
            },

            onInvalid: function(model, errors) {
                LERegistration.logger.info("entering function","RegistrationCreateAccountView:onInvalid");

                this.loader.close();
                cleanAllErrorBubbles();

                var errMsgs= setAllErrorBubbles(errors);
            },


            onRender:function () {
                LERegistration.logger.info("RegistrationCreateAccountView >> onRender >> START");

                this.uiComponents.firstNameInput.setValue(this.model.get("firstName"));
                this.listenTo(this.uiComponents.firstNameInput, InputField.TRIGGERING.CHANGE, this.updateFirstName);

                this.uiComponents.lastNameInput.setValue(this.model.get("lastName"));
                this.listenTo(this.uiComponents.lastNameInput, InputField.TRIGGERING.CHANGE, this.updateLastName);

                this.uiComponents.websiteInput.setValue(this.model.get("website"));
                this.listenTo(this.uiComponents.websiteInput, InputField.TRIGGERING.CHANGE, this.updateWebsite);

                this.uiComponents.passwordInput.setValue(this.model.get("password"));
                this.listenTo(this.uiComponents.passwordInput, InputField.TRIGGERING.CHANGE, this.updatePassword);

                LERegistration.logger.info("RegistrationCreateAccountView >> onRender >> END");
            },

            updateFirstName: function(firstName){
                this.model.set("firstName", firstName);
                this.registrationCreateAccountModel.set("name", firstName + " " + this.model.get("lastName"));
            },
            updateLastName: function(lastName){
                this.model.set("lastName", lastName);
                this.registrationCreateAccountModel.set("name", this.model.get("firstName") + " " + lastName);
            },
            updateWebsite: function(website){
                this.model.set("website", website);
            },
            updatePassword: function(password){
                this.model.set("password", password);
            },
            onShow:function () {
                LERegistration.logger.info("RegistrationCreateAccountView >> onShow >> START");
                LERegistration.logger.info("RegistrationCreateAccountView >> onShow >> END");
            },

            validateFirstName: function(){
                LERegistration.logger.info("RegistrationCreateAccountView >> validateFirstName >> START");
                var errors = {};

                if ( ValidationUtilities.isEmpty(this.uiComponents.firstNameInput.getValue()) ) {
                    LERegistration.logger.info("RegistrationCreateAccountView >> validateFirstName >> first name empty");
                    errors[ERRORS.FIRST_NAME_EMPTY] = LE.translator.translate("LERegistration.FieldMandatory");
                }else {
                    if (!XRegExp.call(this, Config.validators.name.regex).test(this.uiComponents.firstNameInput.getValue())) {
                        errors[ERRORS.FIRST_NAME_INVALID] = LE.translator.translate("LERegistration.error.enter.valid.first.name");
                    }
                }
                LERegistration.logger.info("RegistrationCreateAccountView >> validateFirstName >> END");
                return errors;
            },

            validateLastName: function(){
                LERegistration.logger.info("RegistrationCreateAccountView >> validateLastName >> START");
                var errors = {};
                if ( ValidationUtilities.isEmpty(this.uiComponents.lastNameInput.getValue()) ) {
                    LERegistration.logger.info("RegistrationCreateAccountView >> validateLastName >> last name empty");
                    errors[ERRORS.LAST_NAME_EMPTY] = LE.translator.translate("LERegistration.FieldMandatory");
                }else {
                    if (!XRegExp.call(this, Config.validators.name.regex).test(this.uiComponents.lastNameInput.getValue())) {
                        errors[ERRORS.LAST_NAME_INVALID] = LE.translator.translate("LERegistration.error.enter.valid.last.name");
                    }
                }
                LERegistration.logger.info("RegistrationCreateAccountView >> validateLastName >> END");
                return errors;
            },

            validateWebsite: function(){
                LERegistration.logger.info("RegistrationCreateAccountView >> validateWebsite >> START");
                var errors = {};
                if ( ValidationUtilities.isEmpty(this.uiComponents.websiteInput.getValue()) ) {
                    LERegistration.logger.info("RegistrationCreateAccountView >> validateWebsite >> website empty");
                    errors[ERRORS.WEB_SITE_EMPTY] = LE.translator.translate("LERegistration.FieldMandatory");
                }else {
                    if (!ValidationUtilities.isValid(this.uiComponents.websiteInput.getValue(), Config.validators.uri.regex)) {
                        errors[ERRORS.WEB_SITE_INVALID] = LE.translator.translate("LERegistration.PleaseEnterValidWebsite");
                    }
                }
                LERegistration.logger.info("RegistrationCreateAccountView >> validateWebsite >> END");
                return errors;
            },

            validatePassword: function(){
                LERegistration.logger.info("RegistrationCreateAccountView >> validatePassword >> START");
                var errors = {};
                if ( ValidationUtilities.isEmpty(this.uiComponents.passwordInput.getValue()) ) {
                    LERegistration.logger.info("RegistrationCreateAccountView >> validatePassword >> password empty");
                    errors[ERRORS.PASSWORD_EMPTY] = LE.translator.translate("LERegistration.FieldMandatory");
                }else {
                    if (!ValidationUtilities.isPasswordValid(this.uiComponents.passwordInput.getValue())) {
                        LERegistration.logger.info("RegistrationCreateAccountView >> validatePassword >> password not valid");
                        errors[ERRORS.PASSWORD_LENGTH] = LE.translator.translate("LERegistration.EnterValidPassword");
                    }
                }
                LERegistration.logger.info("RegistrationCreateAccountView >> validatePassword >> END");
                return errors;
            },

            validateConfirmPassword: function(){
                LERegistration.logger.info("RegistrationCreateAccountView >> validateConfirmPassword >> START");
                var errors = {};
                if (this.uiComponents.passwordInput.getValue() !== this.uiComponents.passwordConfirmInput.getValue()) {
                    errors[ERRORS.PASSWORD_MATCH] = LE.translator.translate("LERegistration.PasswordsNotMatch");
                }
                LERegistration.logger.info("RegistrationCreateAccountView >> validateConfirmPassword >> END");
                return errors;
            },

            doValidate: function(){
                LERegistration.logger.info("RegistrationCreateAccountView >> doValidate >> START");
                var errors = {};
                _.extend(errors, this.validateFirstName());
                _.extend(errors, this.validateLastName());
                _.extend(errors, this.validateWebsite());
                _.extend(errors, this.validatePassword());
                _.extend(errors, this.validateConfirmPassword());

                if (_.isEmpty(errors)){
                    LERegistration.logger.info("RegistrationFailedCreateAccountView >> doValidate >> is valid");
                    return false;
                }else{
                    //show general error
                    //LERegistration.notifier.showError(LE.translator.translate("LEFramework.errors.generalError.on.page"));

                    //show only first error
                    //LERegistration.notifier.showError(errors[Object.keys(errors)[0]]);

                    //show all errors
                    var errMsgs= _.uniq(_.values(errors)).join("<br>");
                    LERegistration.notifier.showError(errMsgs);

                    //LERegistration.notifier.showError(LE.translator.translate("LEFramework.errors.generalError.on.page"));
                    LERegistration.logger.info("RegistrationFailedCreateAccountView >> doValidate >> has errors >> errors=" + errors);
                    return errors;
                }
                LERegistration.logger.info("RegistrationCreateAccountView >> doValidate >> END");
            },

            registrationCreateAccount: function (ev) {
                LERegistration.logger.info("RegistrationCreateAccountView >> registrationCreateAccount >> START");
                this.loader = new Loader({
                    permutation: Loader.PERMUTATION.A,
                    el: ".registration-create-account-view"
                }).render();

                //send Adwords conversion, should be removed when moving this function to the RegistrationController.
                LERegistration.logger.info("RegistrationCreateAccountView >> injecting free trial Adwords Conversion image");
                DomUtil.injectImgToBody("adwordsFreeRequest","//www.googleadservices.com/pagead/conversion/1072532439/?label=gzDoCLrByQkQ15e2_wM&guid=ON&script=0");

                //TODO(oded): notify main controller that registrationFreeTrialAccountCreated (will be needed for the MercuryMedia pixel implementation)

                var errors = this.doValidate();
                if (errors){
                    LERegistration.logger.info("RegistrationCreateAccountView >> registrationCreateAccount >> has errors >> errors=" + errors);
                    this.onInvalid(null, errors);
                }else{
                    LERegistration.logger.info("RegistrationCreateAccountView >> registrationCreateAccount >> is valid");
                    this.model.set("location", this.uiComponents.regLocation.getValue());
                    this.model.set("industry", this.uiComponents.regIndustry.getValue());
                    var options = {
                        success: function (model, response) {
                            LERegistration.logger.info("RegistrationCreateAccountView >> registrationCreateAccount >> success >> START");
                            GoogleAnalytics._runGoogleAnalyticsEvent('SignUpComplete');
                            try {
                                LERegistration.logger.info("Site Created: " + model.attributes.siteId + ". response=" + response);
                                try {
                                    LERegistration.logger.info("Site Created: " + model.attributes.siteId + ". response=" + JSON.stringify(response));
                                } catch (ex){
                                    LERegistration.logger.info("CreateAccount >> response is not a valid json ex=" + ex);
                                }
                                LERegistration.logger.info("Site Created: " + model.attributes.siteId + ". response=" + response);
                                doAutoLogin(that, model.attributes.domain, model.attributes.siteId, model.attributes.username, model.attributes.password);
                            } catch (ex) {
                                LERegistration.logger.info("CreateAccount >> problem during success ex=" + ex);
                            }
                            LERegistration.logger.info("RegistrationCreateAccountView >> registrationCreateAccount >> success >> END");
                        },
                        error: _.bind(function (model, response) {
                            var message= "Account create api failed with errors.";
                            var errorCode = errorCodes.accountCreationFailed;
                            var returnPage = "createAccount";

                            LERegistration.logger.info(message, "RegistrationCreateAccountView:registrationCreateAccount");
                            this.loader.close();

                            //TODO: deprecate errorCode to only code
                            if ((response && response.responseError && response.responseError.code && response.responseError.code === 6) ||
                                (response && response.responseError && response.responseError.errorCode && response.responseError.errorCode === 6) ) {
                                LERegistration.notifier.showError(LE.translator.translate("LERegistration.InvalidFiled").replace("{0}", LE.translator.translate("LERegistration.TypeLettersFieldBelow")));
                            }else{
                                LERegistration.controller.handleRegistrationError(message, errorCode, returnPage, null, response);
                            }
                        }, this)
                    };
                    if (ValidationUtilities.isEmpty(this.automationSecret)){
                        options.headers = {
                            "CaptchaDAO-Challenge": "",
                            "CaptchaDAO-Response": ""
                        };
                    } else {
                        options.headers = {
                            "Automation-Secret": this.automationSecret,
                            "email-token": this.registrationCreateAccountModel.get("token")
                        };
                    }

                    //TODO(oded)- trigger to controller to save model onbehalf
                    this.model.save(null, options);
                    LERegistration.logger.info("RegistrationCreateAccountView >> registrationCreateAccount >> request sent");
                    LERegistration.logger.info("RegistrationCreateAccountView >> registrationCreateAccount >> END");
                }
            },

            licenseAgreement: function() {
                LERegistration.logger.info("RegistrationCreateAccountView >> licenseAgreement >> START");
                //TODO: internationalize terms
                LERegistration.router.open("http://www.liveperson.com/policies/license-agreement");
                LERegistration.logger.info("RegistrationCreateAccountView >> licenseAgreement >> END");
            },

            _getIndustry: function() {
                var value = 'Other';

                if (this.model.get("industry")) {
                    value = this.model.get("industry");
                }

                return value;
            },

            onClose : function(){
                LERegistration.logger.info("RegistrationCreateAccountView >> onClose >> START");
                //close all components
//                this.nameInput.close();
//                this.websiteInput.close();
//                this.passwordInput.close();
//                this.passwordConfirmInput.close();
                LERegistration.logger.info("RegistrationCreateAccountView >> onClose >> END");
            }
        });

        function getCountries() {
            LERegistration.logger.info("RegistrationCreateAccountView >> getCountries >> START and RETURN countriesCollection");
            //{"af": "Afganistan","dz": "Algeria","ao": "Angola","ai": "Anguilla","ag": "Antigua","ar": "Argentina","aw": "Aruba","au": "Australia","at": "Austria","bs": "Bahamas","bh": "Bahrain","bd": "Bangladesh","bb": "Barbados","be": "Belgium/Luxembourg","bm": "Bermuda","bo": "Bolivia","bw": "Botswana","br": "Brazil","vg": "British Virgin Islands","bn": "Brunei Darussalam","bg": "Bulgaria","bf": "Burkina Faso","cm": "Cameroon","ca": "Canada","ky": "Cayman Islands","td": "Chad","cl": "Chile","cn": "China","co": "Colombia","cg": "Congo","cr": "CostaRica","hr": "Croatia","cw": "Curacao","cy": "Cyprus","cz": "CzechRepublic","dk": "Denmark","dm": "Dominica","cd": "Congo","ec": "Ecuador","eg": "Egypt","ee": "Estonia","et": "Ethiopia","fi": "Finland","fr": "France","ga": "Gabon","de": "Germany","gh": "Ghana","gr": "Greece","gd": "Grenada","gy": "Guyana","hk": "HongKong","hu": "Hungary","in": "India","id": "Indonesia","iq": "Iraq","ie": "Ireland","il": "Israel","it": "Italy","ci": "Ivory","jm": "Jamaica","jp": "Japan","jo": "Jordan","kz": "Kazakhstan","ke": "Kenya","kr": "Korea","kw": "Kuwait","lv": "Latvia","lb": "Lebanon","lt": "Lithuania","ly": "Libya","mg": "Madagascar","mw": "Malawi","my": "Malaysia","mu": "Mauritius","mx": "Mexico","ms": "Montserrat","ma": "Morocco","mz": "Mozambique","na": "Namibia","np": "Nepal","nl": "Netherlands","nz": "NewZealand","ne": "Niger","ng": "Nigeria","no": "Norway","om": "Oman","pk": "Pakistan","py": "Paraguay","pe": "Peru","ph": "Philippines","pl": "Poland","pt": "Portugal","qa": "Qatar","ro": "Romania","ru": "Russian","kn": "SaintKittsandNevis","lc": "SaintLucia","vc": "SaintVincentandtheGrenadines","sa": "SaudiArabia","sn": "Senegal","rs": "Serbia","sc": "Seychelles","sl": "Sierra","sg": "Singapore","sk": "Slovakia","si": "Slovenia","za": "SouthAfrica","es": "Spain","lk": "SriLanka","sr": "Suriname","se": "Sweden","ch": "Switzerland","tw": "Taiwan","tz": "Tanzania,","th": "Thailand","tt": "TrinidadandTobago","tn": "Tunisia","tr": "Turkey","tc": "TurksandCaicosIslands","ug": "Uganda","ua": "Ukraine","ae": "United Arab Emirates","uk": "United Kingdom","us": "United States","uy": "Uruguay","uz": "Uzbekistan","ve": "Venezuela","vn": "Vietnam","ye": "Yemen","zm": "Zambia","zw": "Zimbabwe","other": "Other"}
            var countries = CountryUtility.getCountries();
            var countriesCollection = new Dropdown.Collection(countries);

            return countriesCollection;
        }

        function getIndustries() {
            LERegistration.logger.info("RegistrationCreateAccountView >> getIndustries >> START and RETURN industriesCollection");
            var industries = IndustryUtility.getIndustries();
            var industriesCollection = new Dropdown.Collection(industries);

            return industriesCollection;
        }


        //TODO (Gal): should export this code (setAllErrorBubbles & setAllErrorBubbles) to a util class
        function cleanAllErrorBubbles(){
            LERegistration.logger.info("RegistrationCreateAccountView >> cleanAllErrorBubbles >> START");
            for(var error in COMPONENTS) {
                that.uiComponents[COMPONENTS[error]].setError(false);
            }
            LERegistration.logger.info("RegistrationCreateAccountView >> cleanAllErrorBubbles >> END");
        }

        function setAllErrorBubbles(errors){
            LERegistration.logger.info("RegistrationCreateAccountView >> setAllErrorBubbles >> START");
            var errMsgs= [];
            for(var error in errors) {
                errMsgs.push(errors[error]);
                that.uiComponents[mapErrorToComponent[error]].setError(true, errors[error] );
            }
            LERegistration.logger.info("RegistrationCreateAccountView >> setAllErrorBubbles >> END");
            return errMsgs;
        }

        function prepareLoginURL(domain, siteId){
            LERegistration.logger.info("RegistrationCreateAccountView >> prepareLoginURL >> START and RETURN login url");
            return "https://" + domain + "/hc/s-" + siteId + "/web/m-LP/mlogin/home.jsp";
        }

        function doAutoLogin(that, domain, siteId, userName, password){
            LERegistration.logger.info("RegistrationCreateAccountView >> doAutoLogin >> START");
            that.ui.autoLoginForm.attr("action", prepareLoginURL(domain, siteId));
            that.ui.autoLoginPassord.val(password);
            that.ui.siteId.val(siteId);
            that.ui.username.val(userName);
            that.ui.lpservice.val("liveEngage");
            that.ui.servicepath.val("a/~~accountid~~/#,~~ssokey~~,firstTimeLogin");
            that.ui.autoLoginForm.submit();
            LERegistration.logger.info("RegistrationCreateAccountView >> doAutoLogin >> END");
        }

        function registrationCreateAccount(ev) {
            // TODO (Gal): move the logic of that.registrationCreateAccount to here, and remove it from the that
            that.registrationCreateAccount(ev);
        }

        function licenseAgreement(){
            that.licenseAgreement();
        }
    });

    return RegistrationCreateAccountView;
});
